import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/hamburger-icon.svg'
import _imports_1 from '@/assets/qstar-logo.svg'
import _imports_2 from '@/assets/profile-picture-placeholder.svg'


const _hoisted_1 = { class: "sticky touch-manipulation select-none top-0 z-50 w-full h-16 shrink-0 bg-white shadow justify-start items-center inline-flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  width: "24",
  height: "24",
  src: _imports_0
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  width: "52",
  height: "26",
  src: _imports_1
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-8 relative bg-gray-100 rounded-2xl" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "32",
    height: "32",
    src: _imports_2
  })
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  class: "relative z-50 select-none touch-manipulation",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_9 = { class: "fixed inset-0 bg-gray-900/80 transition-opacity" }
const _hoisted_10 = { class: "fixed inset-0 flex select-none" }
const _hoisted_11 = { class: "relative mr-16 flex w-full max-w-xs flex-1" }
const _hoisted_12 = { class: "absolute left-full top-0 flex w-16 justify-center pt-5" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close sidebar", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 text-white",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "flex grow flex-col gap-y-0 overflow-y-auto bg-gray-50 px-6 pb-4 transform" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "flex h-16 shrink-0 items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "52",
    height: "26",
    src: _imports_1,
    alt: "qstar-logo"
  })
], -1)
const _hoisted_18 = { class: "flex flex-1 flex-col" }
const _hoisted_19 = {
  role: "list",
  class: "flex flex-1 flex-col gap-y-7"
}
const _hoisted_20 = {
  role: "list",
  class: "-mx-2 space-y-1"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "h-6 w-6 shrink-0" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "h-6 w-6 shrink-0 fill-primary",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_10_4440)" }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M18.5 12C18.5 13.7239 17.8152 15.3772 16.5962 16.5962C15.3772 17.8152 13.7239 18.5 12 18.5C10.2761 18.5 8.62279 17.8152 7.40381 16.5962C6.18482 15.3772 5.5 13.7239 5.5 12C5.5 10.2761 6.18482 8.62279 7.40381 7.40381C8.62279 6.18482 10.2761 5.5 12 5.5C13.7239 5.5 15.3772 6.18482 16.5962 7.40381C17.8152 8.62279 18.5 10.2761 18.5 12ZM4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12ZM11.25 7.75V12C11.25 12.25 11.375 12.4844 11.5844 12.625L14.5844 14.625C14.9281 14.8562 15.3938 14.7625 15.625 14.4156C15.8562 14.0687 15.7625 13.6062 15.4156 13.375L12.75 11.6V7.75C12.75 7.33437 12.4156 7 12 7C11.5844 7 11.25 7.33437 11.25 7.75Z" })
    ])
  ])
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "h-6 w-6 shrink-0" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "h-6 w-6 shrink-0" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "h-6 w-6 shrink-0" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "h-6 w-6 shrink-0" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "h-6 w-6 shrink-0 fill-primary",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_10_4447)" }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M9.42857 4C9.42857 3.525 9.04643 3.14285 8.57143 3.14285C8.09643 3.14285 7.71429 3.525 7.71429 4V5.42857H6.28571C5.025 5.42857 4 6.45357 4 7.71428V8.28571V10V19.1429C4 20.4036 5.025 21.4286 6.28571 21.4286H17.7143C18.975 21.4286 20 20.4036 20 19.1429V10V8.28571V7.71428C20 6.45357 18.975 5.42857 17.7143 5.42857H16.2857V4C16.2857 3.525 15.9036 3.14285 15.4286 3.14285C14.9536 3.14285 14.5714 3.525 14.5714 4V5.42857H9.42857V4ZM5.71429 10H18.2857V19.1429C18.2857 19.4571 18.0286 19.7143 17.7143 19.7143H6.28571C5.97143 19.7143 5.71429 19.4571 5.71429 19.1429V10Z" })
    ])
  ])
], -1)
const _hoisted_26 = { class: "mt-auto" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "h-6 w-6 shrink-0" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "h-6 w-6 shrink-0 fill-primary",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M96 64h84c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H96c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h84c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H96c-53 0-96-43-96-96V160c0-53 43-96 96-96zm231.1 19.5l-19.6 19.6c-4.8 4.8-4.7 12.5 .2 17.1L420.8 230H172c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h248.8L307.7 391.7c-4.8 4.7-4.9 12.4-.2 17.1l19.6 19.6c4.7 4.7 12.3 4.7 17 0l164.4-164c4.7-4.7 4.7-12.3 0-17l-164.4-164c-4.7-4.6-12.3-4.6-17 .1z" })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args))),
        class: "flex w-16 self-stretch justify-center items-center"
      }, _hoisted_3),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goto('/'))),
        class: "grow shrink basis-0 self-stretch flex-col justify-center items-center gap-2.5 inline-flex"
      }, _hoisted_5),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goto('/info'))),
        class: "flex w-16 self-stretch px-4 justify-start items-center"
      }, _hoisted_7)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_Transition, {
        "enter-active-class": "ease-in-out duration-500",
        "leave-active-class": "ease-in-out duration-500",
        "enter-class": "opacity-0",
        "enter-to-class": "opacity-100",
        "leave-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_9, null, 512), [
            [_vShow, _ctx.isOpen]
          ])
        ]),
        _: 1
      }),
      _withDirectives(_createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args))),
              type: "button",
              class: "-m-2.5 p-2.5"
            }, _hoisted_15)
          ]),
          _createVNode(_Transition, {
            "enter-active-class": "ease-in-out duration-500",
            "leave-active-class": "ease-in-out duration-500",
            "enter-class": "-translate-x-full",
            "enter-to-class": "translate-x-0",
            "leave-class": "translate-x-0",
            "leave-to-class": "-translate-x-full"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("nav", _hoisted_18, [
                  _createElementVNode("ul", _hoisted_19, [
                    _createElementVNode("li", null, [
                      _createElementVNode("ul", _hoisted_20, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goto('/reports'))),
                            class: "bg-gray-200 text-primary group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold cursor-pointer"
                          }, [
                            _hoisted_21,
                            _createTextVNode(" Indberetninger ")
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goto('/reports/week/time'))),
                            class: "text-secondary hover:bg-gray-200 group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold cursor-pointer"
                          }, [
                            _hoisted_22,
                            _createTextVNode(" Timesedler ")
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goto('/reports/week/transport'))),
                            class: "text-secondary hover:bg-gray-200 group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold cursor-pointer"
                          }, [
                            _hoisted_23,
                            _createTextVNode(" Transport ")
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goto('/reports/week/sick'))),
                            class: "text-secondary hover:bg-gray-200 group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold cursor-pointer"
                          }, [
                            _hoisted_24,
                            _createTextVNode(" Sygdom ")
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.goto('/mobilization/plan'))),
                            class: "text-secondary hover:bg-gray-200 group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold cursor-pointer"
                          }, [
                            _hoisted_25,
                            _createTextVNode(" Min plan / Mobiliseringer ")
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_26, [
                      _createElementVNode("a", {
                        href: "#/login",
                        class: "text-secondary hover:bg-gray-200 group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold cursor-pointer",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.signOut()))
                      }, [
                        _hoisted_27,
                        _createTextVNode(" Log ud ")
                      ])
                    ])
                  ])
                ])
              ], 512), [
                [_vShow, _ctx.isOpen]
              ])
            ]),
            _: 1
          })
        ])
      ], 512), [
        [_vShow, _ctx.isOpen]
      ])
    ])
  ], 64))
}